var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoSecondaryIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.5,
    height: 14.5,
    viewBox: "0 0 14.5 14.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Info_13px",
    transform: "translate(-549.25 -325.25)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "information-circle-outline",
    transform: "translate(486 262)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_972",
    "data-name": "Path 972",
    d: "M70.5,64A6.5,6.5,0,1,0,77,70.5,6.5,6.5,0,0,0,70.5,64Z",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2502",
    "data-name": "Group 2502"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_973",
    "data-name": "Path 973",
    d: "M220,220h1.005v3.76",
    transform: "translate(-150.186 -150.051)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_974",
    "data-name": "Path 974",
    d: "M208,340h2.765",
    transform: "translate(-138.765 -266)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_975",
    "data-name": "Path 975",
    d: "M222.95,130a.95.95,0,1,0,.95.95A.95.95,0,0,0,222.95,130Z",
    transform: "translate(-152.313 -63.005)",
    fill: "currentColor"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoSecondaryIcon);
export default __webpack_public_path__ + "static/media/info-secondary-icon.229d14716b0d5a7d9a8c614990f41d57.svg";
export { ForwardRef as ReactComponent };